/* Genuvia — scripts propios. Todo vanilla, sin librerías. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- animaciones de entrada ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.gv-reveal:not(.gv-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('gv-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('gv-visible');
          obs.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- parallax suave de la imagen de portada ---------- */
  function initParallax() {
    var capas = document.querySelectorAll('[data-gv-parallax]');
    if (!capas.length || reduce) return;
    var activo = false;
    function pinta() {
      capas.forEach(function (el) {
        var fuerza = parseFloat(el.getAttribute('data-gv-parallax')) || 0;
        if (!fuerza) return;
        var r = el.getBoundingClientRect();
        var centro = r.top + r.height / 2 - window.innerHeight / 2;
        el.style.transform = 'translate3d(0,' + (-centro * fuerza).toFixed(1) + 'px,0)';
      });
      activo = false;
    }
    function pide() {
      if (!activo) { activo = true; requestAnimationFrame(pinta); }
    }
    window.addEventListener('scroll', pide, { passive: true });
    window.addEventListener('resize', pide);
    pide();
  }

  /* ---------- anatomía: puntos numerados <-> tarjetas ---------- */
  function initAnatomia() {
    document.querySelectorAll('[data-gv-anatomia]').forEach(function (raiz) {
      var puntos = raiz.querySelectorAll('[data-gv-punto]');
      var items = raiz.querySelectorAll('[data-gv-item]');
      if (!puntos.length) return;

      function marca(clave, fijo) {
        puntos.forEach(function (p) { p.setAttribute('aria-pressed', p.getAttribute('data-gv-punto') === clave ? 'true' : 'false'); });
        items.forEach(function (i) { i.classList.toggle('gv-activo', i.getAttribute('data-gv-item') === clave); });
        if (fijo) raiz.setAttribute('data-gv-fijo', clave);
      }
      function limpia() {
        if (raiz.getAttribute('data-gv-fijo')) return;
        puntos.forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
        items.forEach(function (i) { i.classList.remove('gv-activo'); });
      }

      puntos.forEach(function (p) {
        var clave = p.getAttribute('data-gv-punto');
        p.addEventListener('mouseenter', function () { marca(clave, false); });
        p.addEventListener('mouseleave', limpia);
        p.addEventListener('click', function () {
          if (raiz.getAttribute('data-gv-fijo') === clave) { raiz.removeAttribute('data-gv-fijo'); limpia(); return; }
          marca(clave, true);
          var item = raiz.querySelector('[data-gv-item="' + clave + '"]');
          if (item && window.innerWidth < 990) item.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        });
      });
      items.forEach(function (i) {
        var clave = i.getAttribute('data-gv-item');
        i.addEventListener('mouseenter', function () { marca(clave, false); });
        i.addEventListener('mouseleave', limpia);
      });
    });
  }

  /* ---------- galería de producto ---------- */
  function initGaleria() {
    document.querySelectorAll('[data-gv-galeria]').forEach(function (galeria) {
      var principal = galeria.querySelector('[data-gv-foto-principal]');
      var minis = galeria.querySelectorAll('[data-gv-mini]');
      if (!principal || !minis.length) return;

      function activa(mini) {
        var src = mini.getAttribute('data-src');
        var srcset = mini.getAttribute('data-srcset');
        var alt = mini.getAttribute('data-alt') || '';
        if (!src || principal.getAttribute('src') === src) {
          minis.forEach(function (m) { m.setAttribute('aria-current', m === mini ? 'true' : 'false'); });
          return;
        }
        principal.classList.add('gv-cambiando');
        var nueva = new Image();
        nueva.onload = function () {
          principal.src = src;
          if (srcset) principal.srcset = srcset;
          principal.alt = alt;
          principal.classList.remove('gv-cambiando');
        };
        nueva.onerror = function () { principal.classList.remove('gv-cambiando'); };
        nueva.src = src;
        minis.forEach(function (m) { m.setAttribute('aria-current', m === mini ? 'true' : 'false'); });
      }

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () { activa(mini); });
      });

      galeria.gvMuestraMedia = function (mediaId) {
        if (!mediaId) return;
        var destino = galeria.querySelector('[data-gv-mini][data-media-id="' + mediaId + '"]');
        if (destino) activa(destino);
      };
    });
  }

  /* ---------- selector de variantes ---------- */
  function initVariantes() {
    document.querySelectorAll('[data-gv-producto]').forEach(function (raiz) {
      var datos = raiz.querySelector('[data-gv-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (err) { return; }
      if (!variantes || !variantes.length) return;

      var campoId = raiz.querySelector('[data-gv-variant-id]');
      var boton = raiz.querySelector('[data-gv-add]');
      var precio = raiz.querySelector('[data-gv-precio]');
      var antes = raiz.querySelector('[data-gv-antes]');
      var descuento = raiz.querySelector('[data-gv-descuento]');
      var galeria = raiz.querySelector('[data-gv-galeria]');
      var textoNormal = boton ? boton.getAttribute('data-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-texto-agotado') : '';

      function seleccionActual() {
        var out = [];
        raiz.querySelectorAll('[data-gv-opcion]').forEach(function (grupo) {
          var marcado = grupo.querySelector('input:checked');
          out.push(marcado ? marcado.value : null);
          var eco = grupo.querySelector('[data-gv-opcion-valor]');
          if (eco && marcado) eco.textContent = marcado.value;
        });
        return out;
      }

      function buscaVariante(sel) {
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i];
          var ok = true;
          for (var j = 0; j < sel.length; j++) {
            if (sel[j] !== null && v.opciones[j] !== sel[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      function actualiza() {
        var v = buscaVariante(seleccionActual());
        if (!v) {
          if (boton) { boton.disabled = true; boton.textContent = textoAgotado; }
          return;
        }
        if (campoId) campoId.value = v.id;
        if (precio) precio.textContent = v.precio;
        if (antes) {
          if (v.antes) { antes.textContent = v.antes; antes.hidden = false; }
          else { antes.hidden = true; }
        }
        if (descuento) {
          if (v.descuento) { descuento.textContent = '-' + v.descuento + '%'; descuento.hidden = false; }
          else { descuento.hidden = true; }
        }
        if (boton) {
          boton.disabled = !v.disponible;
          boton.textContent = v.disponible ? textoNormal : textoAgotado;
        }
        if (galeria && galeria.gvMuestraMedia && v.media) galeria.gvMuestraMedia(String(v.media));
        if (raiz.gvActualizaPack && v.precio_cents) raiz.gvActualizaPack(v.precio_cents);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (err) { /* sin soporte, no pasa nada */ }
      }

      raiz.querySelectorAll('[data-gv-opcion] input').forEach(function (input) {
        input.addEventListener('change', actualiza);
      });
      actualiza();
    });
  }

  /* ---------- añadir al carrito sin recargar (cajón lateral de Dawn) ---------- */
  function initCarrito() {
    document.querySelectorAll('[data-gv-producto] form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.gvListo === '1') return;
      form.dataset.gvListo = '1';

      form.addEventListener('submit', function (e) {
        var cesta = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (!cesta || typeof cesta.renderContents !== 'function' || typeof window.routes === 'undefined') return;

        e.preventDefault();
        var boton = form.querySelector('[data-gv-add]');
        var textoOriginal = boton ? boton.textContent : '';
        if (boton) {
          boton.disabled = true;
          boton.textContent = boton.getAttribute('data-texto-cargando') || 'Añadiendo…';
        }

        var datos = new FormData(form);
        try {
          var ids = cesta.getSectionsToRender().map(function (s) { return s.id; });
          datos.append('sections', ids);
          datos.append('sections_url', window.location.pathname);
          if (cesta.classList) cesta.classList.remove('is-empty');
        } catch (err) { /* si Dawn cambia, seguimos igualmente */ }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: datos,
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { form.submit(); return; }
            cesta.renderContents(res);
            if (cesta.tagName === 'CART-DRAWER' && typeof cesta.open === 'function') cesta.open();
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            if (boton) {
              boton.disabled = false;
              boton.textContent = textoOriginal;
            }
          });
      });
    });
  }

  /* ---------- selector de 1 o 2 unidades ---------- */
  /* Reescribe un importe imitando el formato con el que Shopify pintó el precio original
     (símbolo, posición y separadores), para que todo se vea igual en cualquier moneda. */
  function formateaComo(plantilla, cents) {
    var m = /(\d[\d.,]*)/.exec(plantilla || '');
    if (!m) return (cents / 100).toFixed(2);
    var num = m[1];
    var dec = num.length > 3 && /[.,]/.test(num.charAt(num.length - 3)) ? num.charAt(num.length - 3) : '';
    var miles = dec === ',' ? '.' : (dec === '.' ? ',' : '');
    var entero = String(Math.floor(cents / 100));
    var resto = String(cents % 100);
    if (resto.length < 2) resto = '0' + resto;
    if (miles) entero = entero.replace(/\B(?=(\d{3})+(?!\d))/g, miles);
    var nuevo = dec ? entero + dec + resto : entero;
    return plantilla.replace(m[1], nuevo);
  }
  function initPack() {
    document.querySelectorAll('[data-gv-producto]').forEach(function (raiz) {
      var pack = raiz.querySelector('[data-gv-pack]');
      var qty = raiz.querySelector('[data-gv-qty]');
      if (!pack || !qty || pack.dataset.gvListo === '1') return;
      pack.dataset.gvListo = '1';
      pack.querySelectorAll('input').forEach(function (input) {
        input.addEventListener('change', function () { if (input.checked) qty.value = input.value; });
      });
      var marcado = pack.querySelector('input:checked');
      if (marcado) qty.value = marcado.value;

      var p1 = pack.querySelector('[data-gv-pack-precio-1]');
      var plantilla = p1 ? p1.textContent.trim() : '';
      var inicial = parseFloat(pack.getAttribute('data-gv-precio-inicial')) || 0;

      /* al cambiar de variante, recalculamos los precios del pack (solo si el precio cambia) */
      raiz.gvActualizaPack = function (precioCents) {
        if (!precioCents || precioCents === inicial || !plantilla) return;
        inicial = precioCents;
        var desc = parseFloat(pack.getAttribute('data-gv-descuento')) || 0;
        var segunda = Math.round(precioCents * desc / 100);
        var p2 = pack.querySelector('[data-gv-pack-precio-2]');
        var a2 = pack.querySelector('[data-gv-pack-antes-2]');
        var ah = pack.querySelector('[data-gv-pack-ahorro]');
        if (p1) p1.textContent = formateaComo(plantilla, precioCents);
        if (p2) p2.textContent = formateaComo(plantilla, precioCents * 2 - segunda);
        if (a2) a2.textContent = formateaComo(plantilla, precioCents * 2);
        if (ah) ah.textContent = formateaComo(plantilla, segunda);
      };
    });
  }

  /* ---------- enlaces con desplazamiento suave a anclas ---------- */
  function initAnclas() {
    document.querySelectorAll('a[data-gv-ancla]').forEach(function (a) {
      if (a.dataset.gvListo === '1') return;
      a.dataset.gvListo = '1';
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        var i = href.indexOf('#');
        if (i < 0) return;
        var destino = document.getElementById(href.slice(i + 1));
        if (!destino) return;
        e.preventDefault();
        destino.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- arranque ---------- */
  function init() {
    initReveal();
    initParallax();
    initAnatomia();
    initGaleria();
    initPack();
    initVariantes();
    initCarrito();
    initAnclas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* el editor de Shopify recarga secciones sueltas: re-inicializamos */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', initReveal);
})();
